/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Account_Audit_Badge_WarningsInputs */

const fr_account_audit_badge_warnings = /** @type {(inputs: Account_Audit_Badge_WarningsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} avertissement(s)`)
};

/**

* @param {Account_Audit_Badge_WarningsInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_badge_warnings = /** @type {((inputs: Account_Audit_Badge_WarningsInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Badge_WarningsInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_badge_warnings(inputs)
});